'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenExpired = tokenExpired;
exports.tokenExpiry = tokenExpiry;
exports.isCoveToken = isCoveToken;

var _base64url = require('base64url');

var _base64url2 = _interopRequireDefault(_base64url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Lightweight function for checking whether or not JWT token has expired
 *
 * @param {string} accessToken
 */
function tokenExpired(accessToken) {
  var payload = parseToken(accessToken);
  var expiry = parseInt(payload.exp, 0);
  var now = Math.round(+new Date() / 1000);

  return now > expiry;
}

function tokenExpiry(accessToken) {
  var payload = parseToken(accessToken);
  var expiry = parseInt(payload.exp, 0);
  var now = Math.round(+new Date() / 1000);
  return expiry - now;
}

/**
 * Check if token is a cognito token
 * @param {string} token
 */
function isCoveToken(token) {
  var payload = parseToken(token);
  return !!payload.webAppName;
}

function parseToken(jwt) {
  if (typeof jwt !== 'string') {
    throw new Error('Access token is not a string');
  }

  // Convert from base64 encoded string to object
  var payload = JSON.parse(_base64url2.default.decode(jwt.split('.')[1]));

  if (!payload || !payload.exp) {
    throw new Error('Invalid JWT payload');
  }

  return payload;
}